import http from "./http-service"
import colors from "@/utils/colors"

export default class NotificationService {

  static find(data) {
    return http.post("notifications/find", data)
      .then((response) => {

        let notifications = response.notifications.slice()

        notifications.forEach((notification) => {
          notification.icon = NotificationService.EVENT_DATA[notification.event].icon
          notification.iconColor = NotificationService.EVENT_DATA[notification.event].color
        })

        return { notifications, notDisplayedCount: response.notDisplayedCount }
      })
  }
  
  static setDisplayed(notificationId) {
    return http.put("notifications/set-displayed", { notificationId })
  }
}

NotificationService.EVENT_DATA = {
  
  "CD0001": { icon: "user plus", color: "green", rgb: colors.green },               //CADASTRO DE USUARIOS VIA PORTAL
  "CD0002": { icon: "edit outline", color: "orange", rgb: colors.orange },          //ATUALIZACAO DE USUARIOS VIA PORTAL
  "CD0003": { icon: "user plus", color: "green", rgb: colors.green },               //CADASTRO DE PROSPECTS VIA PORTAL
  "CD0004": { icon: "users", color: "purple", rgb: colors.purple },                 //ALTERACAO DE GRUPO DE USUARIOS
  "CD0005": { icon: "info circle", color: "blue", rgb: colors.blue },               //MENSAGEM DE BOAS-VINDAS
  
  "LG0001": { icon: "sign-in", color: "black", rgb: colors.black },                 //LOGIN NO PORTAL
  "LG0002": { icon: "sign-out", color: "black", rgb: colors.black },                //LOGOUT NO PORTAL

  "OC0001": { icon: "plus square", color: "green", rgb: colors.green },             //INCLUSAO DE ORCAMENTOS
  "OC0002": { icon: "edit outline", color: "blue", rgb: colors.blue },              //ALTERACAO DE ORCAMENTOS
  "OC0003": { icon: "trash", color: "red", rgb: colors.red },                       //EXCLUSAO DE ORCAMENTOS
  "OC0004": { icon: "times circle", color: "red", rgb: colors.red },                //CANCELAMENTO DE ORCAMENTOS
  "OC0005": { icon: "check square", color: "green", rgb: colors.green },            //FINALIZACAO DA MANUTENCAO DE ORCAMENTOS
  "OC0006": { icon: "share", color: "teal", rgb: colors.teal },                     //ORCAMENTOS AGUARDANDO APROVACAO
  "OC0007": { icon: "magic", color: "teal", rgb: colors.teal },                     //ORCAMENTOS EM APROVACAO
  "OC0008": { icon: "thumbs up", color: "green", rgb: colors.green },               //APROVACAO DE ORCAMENTOS
  "OC0009": { icon: "thumbs down", color: "red", rgb: colors.red },                 //REJEICAO DE ORCAMENTOS
  "OC0010": { icon: "undo", color: "orange", rgb: colors.orange },                  //DESISTENCIA DA DECISAO DE APROV./REJEICAO DE ORCAMENTOS
  "OC0011": { icon: "lock", color: "orange", rgb: colors.orange },                  //BLOQUEIO DA ALTERACAO DE ORCAMENTOS
  "OC0012": { icon: "unlock alternate", color: "teal", rgb: colors.teal },          //DESBLOQUEIO DA ALTERACAO DE ORCAMENTOS
  "OC0013": { icon: "undo", color: "orange", rgb: colors.orange },                  //DESISTENCIA DE APROVACAO ORCAMENTOS
  "OC0014": { icon: "check circle outline", color: "green", rgb: colors.green },    //APROVACAO TECNICA DE ORCAMENTOS
  "OC0015": { icon: "times circle outline", color: "danger", rgb: colors.danger },  //REJEICAO TECNICA DE ORCAMENTOS
  "OC0016": { icon: "check", color: "green", rgb: colors.green },                   //CONFIRMACAO DE ORCAMENTOS
  "OC0017": { icon: "dollar sign", color: "green", rgb: colors.green },             //EMISSAO DE NOTA FISCAL DE ORCAMENTOS
  "OC0018": { icon: "exclamation circle", color: "red", rgb: colors.red  },         //ERRO AO PROCESSAR ORCAMENTO

  "RE0001": { icon: "thumbs up", color: "green", rgb: colors.green },               //MANIFESTO DE INTERESSE EM PRODUTOS
  "RE0002": { icon: "lock", color: "green", rgb: colors.green },                    //RESERVA DE PRODUTOS
  "RE0003": { icon: "times", color: "red", rgb: colors.red },                       //CANCELAMENTO DE RESERVA DE PRODUTOS
  "RE0004": { icon: "exclamation circle", color: "orange", rgb: colors.orange },    //EXPIRACAO DE RESERVA DE PRODUTOS
  "RE0005": { icon: "check", color: "green", rgb: colors.green },                   //CONFIRMACAO DE RESERVA DE PRODUTOS
  "RE0006": { icon: "undo", color: "red", rgb: colors.red },                        //ESTORNO DE CONFIRMACAO DE RESERVA DE PRODUTOS

  "TU0001": { icon: "check square", color: "teal", rgb: colors.teal },              //ACEITE DOS TERMOS DE USO
  "TU0002": { icon: "times circle", color: "red", rgb: colors.red },                //REJEICAO DOS TERMOS DE USO
}